/**
 * Icon mapping for activity timeline entries.
 */
import {
  Activity,
  Edit,
  Lightbulb,
  PlusCircle,
  RotateCcw,
  Trash2,
  type LucideIcon,
} from "lucide-react";
import type { WebsiteActionType } from "@/types/activity.types";

export const activityIconMap: Partial<Record<WebsiteActionType, LucideIcon>> =
  {
    CREATE: PlusCircle,
    UPDATE: Edit,
    DELETE: Trash2,
    RESTORE: RotateCcw,
    SUGGEST: Lightbulb,
  };

export const defaultActivityIcon = Activity;
